angular.module('app').directive('apFormAttachment',
        function() {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: '/app/views/directives/apFormAttachment.html',
                scope: {
                    // Use '@' for one way binding.  String value is returned.
                    // Use '=' for two way binding.  An object is returned.
                    // Use '&' for a method.
                    attachmentDto : '=attachmentDto',
                    practiceForm : '=practiceForm',
                    sending : '=sending'
                },

                controller: function($scope) {

                    $scope.attachmentDto = {
                        Data: null,
                        FileName: null,
                        MimeType : null,
                        Extension : null
                    };

                    $scope.selectDocumentModel = {
                        selectedFileName: $scope.selectedFileName,
                        selectedFileContents: $scope.selectedFileContents,
                        selectedMimeType: $scope.selectedMimeType,
                        validationMessage: $scope.validationMessage
                    };

                    $scope.$watch('selectDocumentModel.selectedFileContents', function(newval, oldval) {

                        if (newval) {


                            if (newval !== oldval) {
                                        $scope.attachmentDto.Data = $scope.selectDocumentModel.selectedFileContents.split(',')[1];
                                        $scope.attachmentDto.FileName = $scope.selectDocumentModel.selectedFileName;
                                        $scope.attachmentDto.MimeType = $scope.selectDocumentModel.selectedMimeType;
                                        $scope.attachmentDto.Extension = $scope.selectDocumentModel.selectedFileName.split('.')[1];
                                    }
                                    $scope.$emit('createMessage');
                                }
                    }, true);





                }
            };
        }
);